<template>
    <div class="page-container year-on-year-analysis-container">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点选择'">
            <div class="tree-container">
                <me-tree
                    ref="myTree"
                    :treeData="treeData"
                    :treeLoading="treeLoading"
                    :treeToolBar="false"
                    :defaultProps="defaultProps"
                    :nodeKey="'mon_id'"
                    :showCheckbox="true"
                    :title="'采集点选择'"
                    :isSingle="true"
                    :showStretch="false"
                    :defaultExpandAll="true"
                    :defaultCheckKeys="defaultCheckKeys"
                    :checkStrictly.sync="checkStrictly"
                    :defaultExpandedKeys="defaultExpandedKeys"
                    @handleCheckBoxClick="handleTreeNodeClick"
                ></me-tree>
            </div>
        </me-collapes>
        <div class="echart-container" :style="{ width: width }">
            <el-scrollbar style="height: 100%">
                <div style="width: 100%;">
                    <div class="btn_list">
                        <div
                            :class="[
                                btnType1Id == item.mon_class_id
                                    ? 'btn_item btn_in'
                                    : 'btn_item btn_not'
                            ]"
                            v-for="(item, index) in btnList1"
                            :key="item.mon_class_id"
                            @click="changeType(1, item)"
                        >
                            {{ item.mon_class_name }}
                        </div>
                    </div>
                </div>
                <div style="width: 100%;">
                    <div class="btn_list">
                        <div
                            :class="[
                                btnType2Id == item.mon_class_id
                                    ? 'btn_item btn_in'
                                    : 'btn_item btn_not'
                            ]"
                            v-for="(item, index) in btnList2"
                            :key="item / mon_class_id"
                            @click="changeType(2, item)"
                        >
                            {{ item.mon_class_name }}
                        </div>
                    </div>
                </div>
                <!-- <div class="chart_title">同比分析趋势图</div> -->
                <div class="table-wrap">
                    <v-chart
                        v-show="chartType == 'chart'"
                        :auto-resize="true"
                        :options="bar"
                        ref="bar"
                        theme="ovilia-green"
                    />
                    <el-table
                        border
                        class="leader-style-table"
                        :data="tableList1"
                        height="100%"
                        v-show="chartType == 'table'"
                    >
                        <el-table-column
                            label="年份"
                            property="time"
                            align="center"
                        ></el-table-column>

                        <el-table-column
                            label="数据"
                            property="data"
                            align="center"
                        ></el-table-column>
                    </el-table>
                </div>
                <div class="table-wrap">
                    <!-- <div class="chart_title">同比分析数据</div> -->

                    <v-chart
                        v-show="chart2Type == 'chart'"
                        :auto-resize="true"
                        :options="bar2"
                        ref="bar2"
                        theme="ovilia-green"
                    />
                    <el-table
                        border
                        class="leader-style-table"
                        :data="tableList2"
                        height="100%"
                        v-show="chart2Type == 'table'"
                    >
                        <el-table-column
                            label="月份"
                            property="time"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="同比"
                            property="data1"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="环比"
                            property="data2"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="本月"
                            property="data3"
                            align="center"
                        ></el-table-column>
                    </el-table>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import {
    getMonTree,
    getMonClassTree,
    getUnitConsumption,
    getMonthUnitConsumption
} from "@/http/api.js";
import { getYoyList } from "@/http/hr";
import utils from "@/utils/utils";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes
    },
    data() {
        return {
            treeData: [],
            checkStrictly: true,
            defaultProps: {
                children: "children",
                label: "mon_name"
            },
            // treeSelect: {},
            defaultCheckKeys: [],
            select_point_id: "",
            tableList: [],
            xAxisData: [],
            active_power: [], //本期
            active_power_ago: [], //同期
            width: "calc(100% - 300px)",
            btnList1: [],
            btnList2: [],
            btnType1Id: 0,
            btnType2: 0,
            xData1: [],
            xData2: [],
            bar1_data: [],
            bar2_tb: [],
            bar2_hb: [],
            bar2_by: [],
            chartType: "chart",
            chart2Type: "chart",
            tableList1: [],
            tableList2: []
        };
    },
    created() {
        this.getUnitPointList();
    },
    mounted() {
        const chart = this.$refs.bar.chart;
        //使点击区域变成pointer
        chart.getZr().on("mousemove", function(params) {
            var pointInPixel = [params.offsetX, params.offsetY];
            if (chart.containPixel("grid", pointInPixel)) {
                chart.getZr().setCursorStyle("pointer");
            }
        });
        //折线图区域点击事件
        chart.getZr().on("click", params => {
            var pointInPixel = [params.offsetX, params.offsetY];
            var pointInGrid = chart.convertFromPixel("grid", pointInPixel);
            var category = chart.getModel().get("xAxis")[0].data[
                pointInGrid[0]
            ];
            if (undefined != category) {
                this.getMonthUnitConsumption(category, this.btnType2Id);
            }
        });
    },
    methods: {
        // type切换
        changeType(n, item) {
            if (n == 1) {
                this.btnType1Id = item.mon_class_id;
                this.btnList2 = item.children;

                let mon_class_id = "";
                this.btnList2 &&
                    this.btnList2.length &&
                    this.btnList2.forEach(item => {
                        mon_class_id += item.mon_class_id + ",";
                    });
                const zonghe = {
                    mon_class_id: mon_class_id,
                    mon_class_name: "综合",
                    mon_class_type: "1"
                };
                this.btnList2 = [zonghe, ...this.btnList2];

                this.btnType2Id =
                    this.btnList2.length > 0 && this.btnList2[0].mon_class_id;
                this.getUnitConsumption(this.btnType2Id);
            } else if (n == 2) {
                this.btnType2Id = item.mon_class_id;
                this.getUnitConsumption(this.btnType2Id);
            }
        },
        doRandom(num) {
            const temp = [];
            for (let i = 0; i < num; i++) {
                temp.push(Math.floor(Math.random() * (230 - 20)) + 20);
            }
            return temp;
        },
        //获取采集点
        getUnitPointList() {
            getMonTree().then(res => {
                if (res && res.error_code === "0") {
                    this.treeData = res.bus_json;
                    this.defaultCheckKeys = [
                        this.treeData.length > 0 && this.treeData[0].mon_id
                    ];
                    this.getMonClassTree(this.defaultCheckKeys[0]);
                    // this.treeData = [
                    //     {
                    //         w_active: "1",
                    //         point_id: "1",
                    //         point_name: "轮胎生产线",
                    //         p_point_id: null,
                    //     },
                    //     {
                    //         w_active: "1",
                    //         point_id: "2",
                    //         point_name: "准备车间",
                    //         p_point_id: null,
                    //         childList: [
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "21",
                    //                 point_name: "挤出",
                    //                 p_point_id: "2",
                    //                 childList: null,
                    //             },
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "22",
                    //                 point_name: "压延",
                    //                 p_point_id: "2",
                    //                 childList: null,
                    //             },
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "23",
                    //                 point_name: "胎圈成型",
                    //                 p_point_id: "2",
                    //                 childList: null,
                    //             },
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "24",
                    //                 point_name: "帘布裁断",
                    //                 p_point_id: "2",
                    //                 childList: null,
                    //             },
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "25",
                    //                 point_name: "贴三角胶条",
                    //                 p_point_id: "2",
                    //                 childList: null,
                    //             },
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "26",
                    //                 point_name: "带束层成型",
                    //                 p_point_id: "2",
                    //                 childList: null,
                    //             },
                    //         ]
                    //     },
                    //     {
                    //         w_active: "1",
                    //         point_id: "3",
                    //         point_name: "成型车间",
                    //         p_point_id: null,
                    //         childList: [
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "31",
                    //                 point_name: "轮胎成型",
                    //                 p_point_id: "3",
                    //                 childList: null,
                    //             },
                    //         ]
                    //     },
                    //     {
                    //         w_active: "1",
                    //         point_id: "4",
                    //         point_name: "硫化车间",
                    //         p_point_id: null,
                    //         childList: [
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "41",
                    //                 point_name: "轮胎蒸汽硫化",
                    //                 p_point_id: "4",
                    //                 childList: null,
                    //             },
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "42",
                    //                 point_name: "轮胎电力硫化",
                    //                 p_point_id: "4",
                    //                 childList: null,
                    //             }
                    //         ]
                    //     },
                    //     {
                    //         w_active: "1",
                    //         point_id: "5",
                    //         point_name: "硫化后",
                    //         p_point_id: null,
                    //         childList: [
                    //             {
                    //                 w_active: "1",
                    //                 point_id: "51",
                    //                 point_name: "检验",
                    //                 p_point_id: "5",
                    //                 childList: null,
                    //             }
                    //         ]
                    //     }
                    // ];

                    // let formatData = this.tickMenuIdFilter().filter(
                    //     res.bus_json
                    // );
                    // this.defaultCheckKeys = [formatData.firstPoint.point_id];
                }
            });
        },
        getMonthUnitConsumption(show_year, mon_class_id) {
            getMonthUnitConsumption({
                show_year,
                mon_class_id
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.xData2 = res.bus_json.show_month;
                    this.bar2_by = res.bus_json.tb_value;
                    this.bar2_hb = res.bus_json.hb_value;
                    this.bar2_tb = res.bus_json.total_value;
                }
            });
        },
        getMonClassTree(mon_id) {
            getMonClassTree({ mon_id }).then(res => {
                if (res && res.error_code == 0) {
                    this.btnList1 = res.bus_json;
                    this.btnType1Id =
                        this.btnList1.length > 0 &&
                        this.btnList1[0].mon_class_id;
                    this.btnList2 =
                        this.btnList1.length > 0 && this.btnList1[0].children;
                    let mon_class_id = "";
                    this.btnList2 &&
                        this.btnList2.length &&
                        this.btnList2.forEach(item => {
                            mon_class_id += item.mon_class_id + ",";
                        });
                    const zonghe = {
                        mon_class_id: mon_class_id,
                        mon_class_name: "综合",
                        mon_class_type: "1"
                    };
                    this.btnList2 = [zonghe, ...this.btnList2];
                    this.btnType2Id =
                        this.btnList2.length > 0 &&
                        this.btnList2[0].mon_class_id;
                    this.getUnitConsumption(this.btnType2Id);
                }
            });
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            this.getMonClassTree(select.mon_id);
        },
        getUnitConsumption(mon_class_id) {
            getUnitConsumption({ mon_class_id }).then(res => {
                if (res && res.error_code == 0) {
                    this.xData1 = res.bus_json.show_year;
                    this.bar1_data = res.bus_json.total_value;
                    this.getMonthUnitConsumption(
                        this.xData1[this.xData1.length - 1],
                        this.btnType2Id
                    );
                }
            });
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 300px)" : "calc(100% - 61px)";
        }
    },
    computed: {
        bar() {
            const options = {
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "5%",
                    top: "13%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["本年"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#0093ea", "#fe7f65"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "年",
                        data: this.xData1,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name:
                            this.btnType2 == 0
                                ? "tce"
                                : this.btnType2 == 1
                                ? "kWh/个"
                                : "kJ/个",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "本年",
                        type: "line",
                        data: this.bar1_data
                    }
                ]
            };
            return options;
        },
        bar2() {
            const options = {
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "5%",
                    top: "13%",
                    containLabel: true
                },

                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: ["同比", "环比", "本月"],
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                color: ["#0093ea", "#fe7f65", "#f2a354"],
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        name: "年",
                        data: this.xData2,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name:
                            this.btnType2 == 0
                                ? "tce"
                                : this.btnType2 == 1
                                ? "kWh/个"
                                : "kJ/个",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: "同比",
                        type: "line",
                        data: this.bar2_tb
                    },
                    {
                        name: "环比",
                        type: "line",
                        data: this.bar2_hb
                    },
                    {
                        name: "本月",
                        type: "line",
                        data: this.bar2_by
                    }
                ]
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
.page-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .el-card {
        background-color: transparent;
        border: 1px solid #56fcff;
    }
    .el-card__header {
        border-bottom: 1px solid #56fcff;
    }
    .el-table__fixed-right::before,
    .el-table__fixed::before {
        height: 0;
    }
    .collapes-block-container {
        margin-right: 0;
    }

    // .el-scrollbar__wrap {
    //     overflow: hidden;
    //     height: 100%;
    // }
    .tree-container {
        width: px2Rem(280px);
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: 5px;
    }
    .echart-container {
        width: calc(100% - 300px);
        margin-left: 20px;
        margin-right: 30px;
        margin-top: 5px;
        transition: width 500ms;
        overflow-y: auto;
        .table-wrap {
            height: 18rem !important;
            width: 100%;
            padding: 1.5rem;
            box-sizing: border-box;
            position: relative;
            .echarts {
                width: 100%;
                height: 100%;
                margin: 20px 0;
            }
            .table_btn_list {
                text-align: right;
                position: absolute;
                top: 20px;
                right: 20px;
                z-index: 99;
            }
        }
        .chart_title {
            text-align: left;
            font-size: 16px;
            border-left: 5px solid #56fcff;
            padding-left: 10px;
            color: #fff;
            margin-bottom: 20px;
        }
        .btn_list {
            display: inline-flex;
            flex-flow: row wrap;
            border: 1px solid #56fbff;
            border-radius: 5px;
            margin-bottom: 10px;
        }
        .btn_item {
            padding: 10px 20px;
            border-right: 1px solid #56fbff;
            cursor: pointer;
            &:last-child {
                border: none;
            }
        }
        .btn_not {
            color: #fff;
            background: transparent;
        }
        .btn_in {
            color: #56fbff;
            background: #005982;
        }
    }
}
</style>
